export class ContentTypeSnippetElements {
    assetElement(element) {
        return element;
    }
    customElement(element) {
        return element;
    }
    dateTimeElement(element) {
        return element;
    }
    guidelinesElement(element) {
        return element;
    }
    linkedItemsElement(element) {
        return element;
    }
    subpagesElement(element) {
        return element;
    }
    multipleChoiceElement(element) {
        return element;
    }
    numberElement(element) {
        return element;
    }
    richTextElement(element) {
        return element;
    }
    taxonomyElement(element) {
        return element;
    }
    textElement(element) {
        return element;
    }
    any(element) {
        return element;
    }
}
export const contentTypeSnippetElementsBuilder = new ContentTypeSnippetElements();
//# sourceMappingURL=content-type-snippet-elements.builder.js.map